import React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import LandingPage from './LandingPage';
import AccountConfirmationPage from './AccountConfirmationPage';
import { ORDER_TYPE } from '../common/constants/OrderType';

export default function App() {
    return (
        <Router history={browserHistory}>
            <Route path='/u/registration/:memberId'>
                <Route path='institution'>
                    <IndexRoute component={(rtProps) => <LandingPage {...rtProps}
                                                                     member={window.config.member}
                                                                     ssoInfo={window.config.ssoInfo}
                                                                     memberServiceMessages={window.config.memberServiceMessages}
                                                                     registrationTokenRecord={window.config.registrationTokenRecord}
                    />} />
                    <Route path="tpo/login" component={(rtProps) => <LandingPage {...rtProps}
                                                                                 member={window.config.member}
                                                                                 ssoInfo={window.config.ssoInfo}
                                                                                 memberServiceMessages={window.config.memberServiceMessages}
                                                                                 orderType={ORDER_TYPE.THIRD_PARTY} />} />
                    <Route path='confirm(/:code)' component={(rtProps) => <AccountConfirmationPage {...rtProps} />} />
                </Route>
            </Route>
        </Router>
    );
}
